// @flow

declare var __BROWSER__: boolean;

export default () => __BROWSER__;
